export default __webpack_public_path__ + "static/media/crops-about.56edf977.png";